export default __webpack_public_path__ + "static/hero-image-8dbad8f4a78c35f48676a72bd00cc870.png";